namespace Gamification.Gamification {
    export interface AssetEsperienzeRisorseRow {
        IdAssetEsperienzaRisorsa?: number;
        UserId?: number;
        TenantId?: number;
        IdAssetEsperienza?: number;
        IdRisorsa?: number;
        IdAssetEsperienzaUserId?: number;
        IdAssetEsperienzaTenantId?: number;
        IdAssetEsperienzaIdDispositivo?: number;
        IdAssetEsperienzaIdTipologiaEsperienza?: number;
        IdAssetEsperienzaIdentifierAssetEsperienza?: string;
        IdAssetEsperienzaNome?: string;
        IdAssetEsperienzaUrlAssetBundle?: string;
        IdAssetEsperienzaVersioneAssetBundle?: number;
        IdAssetEsperienzaUrlCoverAssetBundle?: string;
        IdRisorsaUserId?: number;
        IdRisorsaTenantId?: number;
        IdRisorsaIdTipologiaRisorsa?: number;
        IdRisorsaIdEstensione?: number;
        IdRisorsaIdTipologiaCaricamento?: number;
        IdRisorsaNome?: string;
        IdRisorsaDescrizione?: string;
        IdRisorsaVersioneAssetBundle?: number;
        IdRisorsaUrlAssetBundle?: string;
        IdRisorsaUrlCoverAssetBundle?: string;
        IdRisorsaEscludi?: number;
    }

    export namespace AssetEsperienzeRisorseRow {
        export const idProperty = 'IdAssetEsperienzaRisorsa';
        export const localTextPrefix = 'Gamification.AssetEsperienzeRisorse';
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdAssetEsperienzaRisorsa = "IdAssetEsperienzaRisorsa",
            UserId = "UserId",
            TenantId = "TenantId",
            IdAssetEsperienza = "IdAssetEsperienza",
            IdRisorsa = "IdRisorsa",
            IdAssetEsperienzaUserId = "IdAssetEsperienzaUserId",
            IdAssetEsperienzaTenantId = "IdAssetEsperienzaTenantId",
            IdAssetEsperienzaIdDispositivo = "IdAssetEsperienzaIdDispositivo",
            IdAssetEsperienzaIdTipologiaEsperienza = "IdAssetEsperienzaIdTipologiaEsperienza",
            IdAssetEsperienzaIdentifierAssetEsperienza = "IdAssetEsperienzaIdentifierAssetEsperienza",
            IdAssetEsperienzaNome = "IdAssetEsperienzaNome",
            IdAssetEsperienzaUrlAssetBundle = "IdAssetEsperienzaUrlAssetBundle",
            IdAssetEsperienzaVersioneAssetBundle = "IdAssetEsperienzaVersioneAssetBundle",
            IdAssetEsperienzaUrlCoverAssetBundle = "IdAssetEsperienzaUrlCoverAssetBundle",
            IdRisorsaUserId = "IdRisorsaUserId",
            IdRisorsaTenantId = "IdRisorsaTenantId",
            IdRisorsaIdTipologiaRisorsa = "IdRisorsaIdTipologiaRisorsa",
            IdRisorsaIdEstensione = "IdRisorsaIdEstensione",
            IdRisorsaIdTipologiaCaricamento = "IdRisorsaIdTipologiaCaricamento",
            IdRisorsaNome = "IdRisorsaNome",
            IdRisorsaDescrizione = "IdRisorsaDescrizione",
            IdRisorsaVersioneAssetBundle = "IdRisorsaVersioneAssetBundle",
            IdRisorsaUrlAssetBundle = "IdRisorsaUrlAssetBundle",
            IdRisorsaUrlCoverAssetBundle = "IdRisorsaUrlCoverAssetBundle",
            IdRisorsaEscludi = "IdRisorsaEscludi"
        }
    }
}
